<section id="about" class="py-16 lg:py-24 bg-white text-slate-800 relative">
  <div class="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
    
    <!-- LEFT: Text & Stats (6 Columns) -->
    <div class="lg:col-span-6 space-y-6">

      <h2 class="text-3xl sm:text-4xl lg:text-5xl font-black text-[#0e3b2e] leading-tight tracking-tight">
        A national evidence backbone for better decisions.
      </h2>

      <p class="text-slate-600 text-base leading-relaxed">
        The National MEL System provides a unified digital infrastructure connecting ministries, departments, and local government authorities. By standardizing indicator frameworks and automating data aggregation, leadership gains immediate visibility into performance trends across all strategic priorities.
      </p>

      <p class="text-slate-600 text-base leading-relaxed">
        From baseline tracking to final evaluation, the platform ensures every public shilling spent translates into verified, auditable results for citizens.
      </p>

      <!-- Stat Badges -->
      <div class="grid grid-cols-3 gap-6 pt-4 border-t border-slate-100">
        <div>
          <p class="text-3xl font-black text-[#0e3b2e]">26+</p>
          <p class="text-xs font-semibold text-slate-500 uppercase tracking-wide">Regions Covered</p>
        </div>
        <div>
          <p class="text-3xl font-black text-[#0e3b2e]">184+</p>
          <p class="text-xs font-semibold text-slate-500 uppercase tracking-wide">Local Councils</p>
        </div>
        <div>
          <p class="text-3xl font-black text-[#0e3b2e]">1+</p>
          <p class="text-xs font-semibold text-slate-500 uppercase tracking-wide">National Repository</p>
        </div>
      </div>
    </div>

    <!-- RIGHT: Image & Floating Card (6 Columns) -->
    <div class="lg:col-span-6 relative">
      <div class="relative rounded-2xl overflow-hidden shadow-2xl border border-slate-200 group">
        <img src="assets/images/plantation-tz.jpg" alt="Government Evidence Backbone" class="w-full h-[420px] object-cover transition-transform duration-700 group-hover:scale-105" />
        <div class="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

        <!-- Floating Card Overlay -->
        <div class="absolute bottom-6 left-6 right-6 p-5 rounded-xl bg-white/95 backdrop-blur-md shadow-lg border border-slate-100">
          <p class="text-xs font-extrabold text-[#e6b012] uppercase tracking-wider mb-1">#1 National M&amp;E Framework</p>
          <p class="text-sm font-bold text-[#0e3b2e] leading-snug">
            Unified system standardizing M&amp;E indicators and performance reporting across 26 regions.
          </p>
        </div>
      </div>
    </div>

  </div>
</section>
